import type { ReactNode } from 'react';
import { Button } from '@/components/ui/primitives';

/**
 * The end of a paged list: how much is on screen, and the way to more.
 *
 * Every list that can outgrow a page ends with this, so none silently stops at
 * its first fifty rows. Pages are fetched by cursor, not by number: rows
 * arriving or leaving while someone reads do not shift what "next" means.
 */
export function LoadMore({
  shown,
  total,
  hasMore,
  busy,
  onMore,
}: {
  readonly shown: number;
  /** When the server knows it; otherwise only what is on screen is said. */
  readonly total?: number | null | undefined;
  readonly hasMore: boolean;
  readonly busy: boolean;
  readonly onMore: () => void;
}): ReactNode {
  if (!hasMore && (total === undefined || total === null || total <= shown)) return null;
  return (
    <div className="row-between load-more">
      <span className="muted text-sm">
        {typeof total === 'number' ? `Показано ${shown} из ${total}` : `Показано ${shown}`}
      </span>
      {hasMore ? (
        <Button busy={busy} onClick={onMore}>
          Показать ещё
        </Button>
      ) : null}
    </div>
  );
}
